document.addEventListener( 'DOMContentLoaded', function () {
  var root = document.querySelector( '.e-div--footer-privacy-choices' );
  if ( ! root ) {
    return;
  }

  function openOneTrust( e ) {
    if ( e ) {
      e.preventDefault();
    }

    var otBtn = root.querySelector( '#ot-sdk-btn' );
    if ( otBtn ) {
      otBtn.click();
      return;
    }

    if ( window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function' ) {
      window.OneTrust.ToggleInfoDisplay();
    }
  }

  // Legacy footer link markup.
  var legacyLink = root.querySelector( ':scope > .e-lnk' );
  if ( legacyLink ) {
    legacyLink.addEventListener( 'click', openOneTrust );
  }

  // Icon beside OneTrust #ot-sdk-btn — OT wires the button itself.
  var iconBtn = root.querySelector( '.e-div--footer-privacy-choices__icon' );
  if ( iconBtn ) {
    iconBtn.addEventListener( 'click', openOneTrust );
  }
} );
